import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { customerAPI } from './customerAPI';

export const getSession = createAsyncThunk('customers/sessions/getSession', async ({ sessionId }) => {
  return customerAPI.getSession({ sessionId });
});

export const getCreditDecisionDetails = createAsyncThunk(
  'customers/sessions/getCreditDecisionDetails',
  async ({ requestReference }) => {
    return customerAPI.getCreditDecisionDetails({ requestReference });
  },
);

export const setCreditDecision = createAsyncThunk(
  'customers/sessions/setCreditDecision',
  async ({ sessionId, decision, limit }, { dispatch }) => {
    await customerAPI.actions.setCreditDecision({ sessionId, decision, limit });
    dispatch(getSession({ sessionId }));
  },
);

export const IdentityVerificationStatuses = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
};

export const setIdentityVerification = createAsyncThunk(
  'customers/sessions/setIdentityVerification',
  async ({ sessionId, decision }, { dispatch }) => {
    await customerAPI.actions.setIdentityVerification({ sessionId, decision });
    dispatch(getSession({ sessionId }));
  },
);

const initialState = {
  error: null,
  session: {
    registrationDateTime: null,
    buyer: null,
    company: null,
    invoiceAddress: null,
    deliveryAddress: null,
    bankIdAction: null,
    creditDecisionDetails: null,
  },
};

const registrationPageSlice = createSlice({
  name: 'registrationPage',
  initialState,
  reducers: {
    resetError: (state, _) => {
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder.addCase(getSession.pending, (state, _) => ({ ...state, error: null }));
    builder.addCase(getSession.fulfilled, (state, { payload: session }) => ({
      ...state,
      session: session,
      error: null,
    }));
    builder.addCase(getSession.rejected, (state, { error }) => {
      state.session = {
        ...initialState.session,
        error,
      };
    });
    builder.addCase(setCreditDecision.pending, (state, _) => ({ ...state, error: null }));
    builder.addCase(setCreditDecision.fulfilled, state => ({
      ...state,
      error: null,
    }));
    builder.addCase(setCreditDecision.rejected, (state, { error }) => {
      state.error = error;
    });
    builder.addCase(getCreditDecisionDetails.pending, (state, _) => ({ ...state, error: null }));
    builder.addCase(getCreditDecisionDetails.fulfilled, (state, { payload: creditDecisionDetails }) => ({
      ...state,
      creditDecisionDetails,
      error: null,
    }));
    builder.addCase(getCreditDecisionDetails.rejected, (state, { error }) => {
      state.error = error;
    });
  },
});

export const {
  actions: { resetError },
  reducer: registrationPageReducer,
} = registrationPageSlice;
